import React from "react";
import { Box, Grid, Stack, Card, Typography, Avatar, List, ListItem, ListItemAvatar, ListItemText, useTheme } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DevicesIcon from "@mui/icons-material/Devices";
import { StatCard } from "../components/charts";
import { DashboardCard } from "../components/DashboardCard";
import { managementStats, recentActivity } from "../data";

export const ManagementDashboard: React.FC = () => {
  const theme = useTheme();

  const statCards = [
    { metric: managementStats.total_users, icon: PeopleIcon },
    { metric: managementStats.active_users, icon: PersonIcon },
    { metric: managementStats.pending_invites, icon: MailOutlineIcon },
    { metric: managementStats.device_connected, icon: DevicesIcon },
  ];

  const getInitials = (name: string) => name.split(" ").map((n) => n[0]).join("").toUpperCase();

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Grid container spacing={3}>
          {statCards.map((stat, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <StatCard metric={stat.metric} icon={stat.icon} />
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <DashboardCard title="Recent Activity" subtitle="Latest participant activity across the platform.">
              <List disablePadding>
                {recentActivity.map((activity, index) => (
                  <ListItem key={index} divider={index < recentActivity.length - 1} sx={{ px: 0 }}>
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 36, height: 36, fontSize: "0.875rem" }}>
                        {getInitials(activity.user)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="body2">
                          <strong>{activity.user}</strong> {activity.action}
                        </Typography>
                      }
                      secondary={activity.time}
                    />
                  </ListItem>
                ))}
              </List>
            </DashboardCard>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};
